import ModulePropertiesPane from '../_MODULE/ModulePropertiesPane.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelAm.mjs'

export default function PropertiesPaneAm(props) {
    return (
        <ModulePropertiesPane
            controllers={
                <>
                    <Text prop="amNo" />
                    <Text prop="amName" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            versionLabel="分析地图版本号"
            {...props}
        />
    )
}
